import { defineBoot } from '#q-app/wrappers'
import Prism from 'prismjs'
import { debounce } from 'quasar'

// Import the languages you need
import 'prismjs/components/prism-markup' // HTML
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-json'
import 'prismjs/components/prism-bash'

// Import plugins
import 'prismjs/plugins/toolbar/prism-toolbar'
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard'
// import 'prismjs/plugins/show-language/prism-show-language'

// Import CSS
import 'prismjs/themes/prism.css'
import 'prismjs/plugins/toolbar/prism-toolbar.css'

const HIGHLIGHT_DELAY = 300

export const $prism = {}

export default defineBoot(({ app, router }) => {
  // Make Prism available globally
  app.config.globalProperties.$prism = Prism

  $prism.highlightAll = debounce(function () {
    // Highlight all code blocks
    const codeBlocks = document.querySelectorAll('code[class^=language]')

    codeBlocks.forEach(block => {
      Prism.highlightElement(block)
    })
  }, HIGHLIGHT_DELAY)

  // Auto-highlight on route changes
  router.afterEach(() => {
    setTimeout($prism.highlightAll, HIGHLIGHT_DELAY)
  })
})
